import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface checkNewUserRequest extends BaseRequest {
  invId: string; //邀请活动ID ,
}

interface checkNewUserResponse extends BaseResponse {
  Data: boolean;
}

/**
 * 获取邀请码
 * @param params
 * @returns
 */
export async function checkNewUser(request: checkNewUserRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/checkNewUser');
  return DsbcApi.fetch<checkNewUserResponse>(url, request, true, options);
}
